import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

import {
  type LearningPathAvailability,
  learningPathAvailabilitySchema,
} from '../schemas/learningPathAvailability.schema';

export type GetLearningPathAvailabilityParams = {
  schoolId: number;
};

// The backend decides whether the school can use learning paths: Red1000 model and at least one
// 3rd-grade (or derived) class in the current school year.
export const getLearningPathAvailability = httpGetAdapter<LearningPathAvailability, GetLearningPathAvailabilityParams>({
  url: (params) => `/v3/trilha-aprendizagem/escolas/${params.schoolId}/elegibilidade`,
  schema: learningPathAvailabilitySchema,
});
